<template>
	<div class="shop-merchant">
    <cart-menu-button>
      <template v-if="quantity > 0">
        <v-list slot="cart-items" three-line dense width="300">
          <cart-item
						:readOnlyQuantity="!allowMultiplePurchase"
					>
            <v-btn
							v-if="allowMultiplePurchase"
              slot="decrease-button"
              icon
              @click="decreaseQuantity()"
            >
              <v-icon large color="primary">mdi-minus</v-icon>
            </v-btn>

            <v-btn
							v-if="allowMultiplePurchase"
              slot="increase-button"
              icon
              @click="increaseQuantity()"
            >
              <v-icon large color="primary">mdi-plus</v-icon>
            </v-btn>
            
            <v-btn icon slot="delete-item" @click="deleteCartItem()">
              <v-icon color="red lighten-1">mdi-delete</v-icon>
            </v-btn>

						<div v-if="setMinimumPurchase > 1" slot="cart-message">
							<p>
								Minimum Purchase: {{ setMinimumPurchase }}
							</p>
						</div>
          </cart-item>
        </v-list>
        
        <router-link
					slot="checkout-button"
					:to="`/shop/promo/checkout/${merchantSlug}`"
				>
          <base-button
            name="Checkout"
            x-large
            color="#0e6ccd"
            dark
						:disabled="!(checkoutQuantity >= setMinimumPurchase)"
          ></base-button>
        </router-link>
      </template>
      <template v-else>
        <v-list slot="cart-items" three-line dense width="300" height="250">
          <v-row justify="center" align="center" class="fill-height">
            <div class="text-center">
              <v-icon x-large>mdi-cart-off</v-icon>
              <p class="text-center grey--text pt-3">You cart is empty</p>
            </div>
          </v-row>
        </v-list>
      </template>
    </cart-menu-button>

    <base-banner
      :title="banner.title"
      :caption="banner.caption"
      :backgroundImage="banner.image"
      :titleColor="banner.titleColor"
      :captionColor="banner.captionColor"
      :backgroundColor="banner.backgroundColor"
			:buttons="banner.buttons"
    >
    </base-banner>

    <base-goto :breadcrumbs="breadcrumbs"></base-goto>

    <base-divider></base-divider>

    <div id="content">
      <notes-ordered-list :notes="notes"></notes-ordered-list>

      <div id="steps" class="white sec">
        <base-title
          title="How to get your unlimited plan"
        ></base-title>

        <v-row justify="center" class="pdx-20">
          <step-column
            v-for="(step, key) in steps"
            :key="key"
            :image="step.image"
            :title="step.title"
            :number="key + 1"
						:line="true"
          ></step-column>
        </v-row>
      </div>

      <div id="plan" class="sec">
        <base-title
          title="Get my exclusive Medgate unliconsultation plan"
          caption="With the plan you can access the Medgate Telemedicine Center with a simple phone call. You can consult a doctor without the hassle of going to the hospital and waiting in line for hours."
          size="1"
        ></base-title>

        <strength-row></strength-row>

        <v-row class="pdx-15" justify="center">
          <v-col
            cols="12" sm="6" md="4" lg="4" xl="4"
            v-for="(plan, key) in plans"
            :key="key"
						class="d-flex"
          >
            <plan-card
              :name="plan.name"
              :price="plan.price"
              :discount="plan.discount"
              :description="plan.description"
              :elevation="((key + 2) % 3) ? 0 : 12"
              @add="addToCart(plan)"
							:disable="quantity > 0 ? true : false"
            ></plan-card>
          </v-col>	
        </v-row>
      </div>

      <div id="testimonial" class="sec white">
        <v-container>
          <base-title
            title="What our happy customers say about the Medgate Unliconsultation Plan"
            size="1"
          ></base-title>

          <v-row justify="center">
            <v-col
              cols="12" sm="6" md="6" lg="6" xl="6"
              v-for="(tes, key) in testimonials"
              :key="key"
							class="d-flex"
            >
              <testimonial-card
                :title="tes.title"
                :description="tes.caption"
                :ratings="tes.ratings"
                :name="tes.name"
              ></testimonial-card>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
	</div>
</template>

<script>
import StrengthRow from "@/components/shop/StrengthRow.vue";
import PlanCard from "@/components/shop/PlanCard.vue";
import TestimonialCard from "@/components/home/TestimonialCard.vue";
import CartMenuButton from "@/components/shop/CartMenuButton.vue";
import CartItem from "@/components/shop/CartItem.vue";
import NotesOrderedList from "@/components/shop/NotesOrderedList.vue";
import StepColumn from "@/components/shop/StepColumn.vue";

import Repository from "@/api/repositories";
const ShopMerchantBannersApi = Repository.get("shopMerchantBanners");
const ShopMerchantPlansApi = Repository.get("shopMerchantPlans");
const ShopTestimonialsApi = Repository.get("shopTestimonials");
const ShopMerchantsApi = Repository.get("shopMerchants");

	export default {
		name: "ShopMerchant",
		components: {
			StrengthRow,
			PlanCard,
			TestimonialCard,
			CartMenuButton,
			CartItem,
			NotesOrderedList,
			StepColumn
		},
		data: () => ({
			merchants: [],
			merchantSlug: '',
			merchantSlugStorage: localStorage.merchantSlug,
      merchantIdStorage: localStorage.merchantId,
			testimonials: [],
			banner: [],
			plans: [],
			notes: [
				"Medgate Unliconsultation Plan is for Philippines residents only since all our Filipino doctors are licensed to practice and prescribe medication in the Philippines only.",
				"The Medgate Unliconsultation Plan is not designed for immediate medical care at the time of purchase.",
				"You will receive the purchase confirmation email within the period of two banking days along with a unique access key and activation code.",
				"Once the account has been activated, the member will be able to access Medgate Philippines’ telemedicine service on demand at any time.",
				"The Medgate Unliconsultation Plan is non-transferrable and can only be used by the assigned account member."
			],
			steps: [
				{
					image: require("@/assets/images/shop_1.png"),
					title: "Fill out the form"
				},
				{
					image: require("@/assets/images/shop_2.png"),
					title: "Pay"
				},
				{
					image: require("@/assets/images/shop_3.png"),
					title: "Wait for the confirmation"
				},
				{
					image: require("@/assets/images/shop_4.png"),
					title: "Activate your access key and activation code"
				}
			],
			breadcrumbs: [
				{
					name: "Medgate",
					link: "/",
					active: false
				},
				{
					name: "Shop Merchants",
					link: "/shop",
					active: true
        }
			]
		}),
		async created() {
			// await this.authenticateUrl();
		},
		computed: {
			quantity: function () {
				return this.$store.getters['merchantCart/quantity']
			},
			total: function() {
        return this.$store.getters['merchantCart/total']
      },
			allowMultiplePurchase: function() {
				return this.merchants.other_details
					? this.merchants.other_details.is_multiple_purchase || false
					: false;
			},
			setMinimumPurchase: function() {
				return this.merchants.other_details
					? this.merchants.other_details.minimum_quantity_purchase || 1
					: 1;
				// let minimumPurchase = this.merchants.other_details
				// 	? this.merchants.other_details.minimum_quantity_purchase || 1
				// 	: 1;
				
				// if (minimumPurchase > 1) {
				// 	return `Minumum Purchase: ${minimumPurchase}`;
				// }

				// return null;
			},
			checkoutQuantity: function() {
				return this.$store.getters['merchantCart/quantity'] || null;
			}
		},
		mounted() {
			this.merchantSlug = this.$route.params.slug
			this.getMerchantViaSlug();
		},
		methods: {
			async authenticateUrl() {
				try {
					const { data } = await ShopMerchantsApi.get();
					let merchants = data.data;
					this.merchants = data.data;

					var slugIndex = merchants.findIndex(item =>
						item.slug == this.$route.params.slug
					);
					
					// if url slug is NOT registered in database
					if (slugIndex < 0) {
						// then REDIRECT to "enter merchant code" page
						// this.$router.push({ name: 'ShopMerchantCode' })
						
						// redirect to not found page
						this.$router.push({ name: 'NotFound' })
					}
					
					// if url slug is REGISTERED
					else {
						// first visit of user in merchant
						if (!this.merchantIdStorage) {
							// save merchant id
							localStorage.setItem('merchantId', this.merchants[slugIndex].id);
						}
						if (!this.merchantSlugStorage) {
							// save new merchant slug
							localStorage.setItem('merchantSlug', this.$route.params.slug);
						}
						
						// if url slug is different form the saved merchant slug
						if (this.merchantSlugStorage !== this.$route.params.slug) {
							// remove merchant cart item from localStorage
							localStorage.removeItem('merchantItem')
							// save new merchant slug
							localStorage.setItem('merchantSlug', this.$route.params.slug);
							// save new merchant id
							localStorage.setItem('merchantId', this.merchants[slugIndex].id);
						}

						this.getShopMerchantPlans(this.merchants[slugIndex].id);
						this.getShopTestimonials();
						await this.getShopMerchantBanner(this.merchants[slugIndex].id);
						this.setHeaderColor();

						// but user visited the page WTIHOUT code input
						// or url slug id is DIFFERENT from the saved localStorage merchant id
						// if (!this.merchantIdStorage || merchants[slugIndex].id != this.merchantIdStorage) {
							// then REDIRECT to "enter merchant code" page
							// this.$router.push({ name: 'ShopMerchantCode' })
						// }
						// else {
						// 	this.getShopMerchantPlans();
						// 	this.getShopTestimonials();
						// 	await this.getShopMerchantBanner();
						// 	this.setHeaderColor();
						// }
					}
					
					console.log('[shop-merchants]', merchants);
				}
				catch(error) {
					console.log(error);
				}
			},
			setHeaderColor() {
				if (this.banner.backgroundColor)
					this.$store.commit('page/setHeaderColor', this.banner.backgroundColor)
				else
					this.$store.commit('page/defaultHeaderColor')
			},
			async getShopMerchantBanner(id) {
				try {
					const { data } = await ShopMerchantBannersApi.get(id);
					
					if (data) {
						data.data.sort(function(a, b) {
							return a.precedence - b.precedence;
						});
						
						let apiData = data.data[0];

						let buttons = apiData.buttons.map(button => {
							return {
								name: button.label,
								icon: button.image,
								link: button.redirect,
								color: JSON.parse(button.styling).color
							}
						});

						let banner = {
							buttons: buttons,
							image: apiData.background_image.main,
							caption: apiData.caption,
							title: apiData.title,
							titleColor: apiData.styles.titleColor,
							captionColor: apiData.styles.captionColor,
							backgroundColor: apiData.styles.backgroundColor
						}

						this.banner = banner;
					}

					console.log('[shop-merchant-banner]', data, this.banner);
				}
				catch(error) {
					console.log(error);
				}
			},
			async getShopMerchantPlans(id) {
				try {
					const { data } = await ShopMerchantPlansApi.get(id);
					
					if (data) {
						data.data.sort(function(a, b) {
							return a.precedence - b.precedence;
						});

						let plans = data.data.map(plan => {
							var details = {
								id: plan.id,
								name: plan.name,
								price: plan.price,
								discount: plan.discount,
								description: plan.description,
								maxDependents: plan.no_key_generate
							}

							if (plan.other_details)
									details.member = plan.other_details.applyDetails
										? parseInt(plan.other_details.amountPerHousehold)
										: null
							else
								details.member = null

							return details
						});

						this.plans = plans;
					}

					console.log('[shop-merchant-plans]', data, this.plans);
				}
				catch(error) {
					console.log(error);
				}
			},
			async getShopTestimonials() {
				try {
					const { data } = await ShopTestimonialsApi.get();
					
					if (data) {
						data.data.sort(function(a, b) {
							return a.precedence - b.precedence;
						});

						let testimonials = data.data.map(tes => {
							return {
								name: tes.name,
								title: tes.title,
								ratings: parseInt(tes.ratings),
								caption: tes.caption
							}
						});

						this.testimonials = testimonials;
					}

					console.log('[shop-testimonials]', data, this.testimonials);
				}
				catch(error) {
					console.log(error);
				}
			},
			addToCart(plan) {
				var item = {
          description: plan.description,
					discount: plan.discount,
					id: plan.id,
					name: plan.name,
					price: plan.price,	
					quantity: 1,
					member: plan.member,
					memberQuantity: 0,
					maxDependents: plan.maxDependents
				}
				console.log('merchant-item', item);
				this.$store.commit('merchantCart/setItem', item);
			},
			deleteCartItem() {
				this.$store.commit('merchantCart/deleteItem')
			},
			increaseQuantity() {
        this.$store.commit('merchantCart/increaseQuantity')
      },
      decreaseQuantity() {
        this.$store.commit('merchantCart/decreaseQuantity')
      },
			async getMerchantViaSlug() {
				let slug = this.$route.params.slug
				await ShopMerchantsApi
					.getViaSlug(slug)
					.then(async response => {
						// console.log({ response });
						// let merchant = response.data.data;
						this.merchants = response.data.data;

						console.log(this.merchants, "merchants");

						if (!this.merchantIdStorage) {
							// save merchant id
							localStorage.setItem('merchantId', this.merchants.id);
						}
						if (!this.merchantSlugStorage) {
							// save new merchant slug
							localStorage.setItem('merchantSlug', this.$route.params.slug);
						}
						
						// if url slug is different form the saved merchant slug
						if (this.merchantSlugStorage !== this.$route.params.slug) {
							// remove merchant cart item from localStorage
							localStorage.removeItem('merchantItem')
							// save new merchant slug
							localStorage.setItem('merchantSlug', this.$route.params.slug);
							// save new merchant id
							localStorage.setItem('merchantId', this.merchants.id);
						}

						this.getShopMerchantPlans(this.merchants.id);
						this.getShopTestimonials();
						await this.getShopMerchantBanner(this.merchants.id);
						this.setHeaderColor();
					})
					.catch(error => {
						console.log({ error });
						this.$router.push({ name: 'NotFound' });
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
</style>